goog.provide("shadow.js.shim.module$src$svg$wpp$content$stack_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$stack_svg");
shadow.js.shim.module$src$svg$wpp$content$stack_svg = shadow.js.nativeProvides["src/svg/wpp/content/stack.svg"] = shadow$bridge("src/svg/wpp/content/stack.svg");
module$shadow_js_shim_module$src$svg$wpp$content$stack_svg.default = shadow.js.shim.module$src$svg$wpp$content$stack_svg;
